import CableReady from 'cable_ready'
import consumer from "./consumer"

if (document.querySelector("meta[name=current_user]")) {
  document.addEventListener('turbolinks:load', () => {

    let slalistSub = document.querySelector("#slalistSub")
    if (slalistSub != null) {
      consumer.subscriptions.create("SlalistChannel", {
        connected() {
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
        },

        received(data) {
          if (data.cableReady) CableReady.perform(data.operations)
        }
      });
    }
  })
}
